import type { EPGEntryDto } from "$src/core/models/dto";
import type { FixedRowProgramLayout } from "$src/core/models/epg";
import programTimeRangeMs from "$src/core/utils/epg/program-time-range-ms";

/** Programs sorted by start time for fixed-height row stacking. */
const layoutProgramsFixedRows = (
  programs: EPGEntryDto[],
): FixedRowProgramLayout[] => {
  const sorted = programs
    .map((entry) => ({ entry, range: programTimeRangeMs(entry) }))
    .filter(
      (
        row,
      ): row is { entry: EPGEntryDto; range: { start: number; end: number } } =>
        row.range != null,
    )
    .sort((a, b) => a.range.start - b.range.start);

  return sorted.map(({ entry }) => ({
    entry,
  }));
};

export default layoutProgramsFixedRows;
